(function ($) {
  var $wrapper = $(".jb-SceneWrapper"),
    $scene = $(".jb-Scene"),
    $indicator = $(".jb-Indicator"),
    $nav = $(".brand-Nav"),
    $bgs = $(".jb-SpBg"),
    $bg,
    wrapperObserver,
    sceneObserver,
    navObserver,
    mq = {
      SP: window.matchMedia("(max-width: 480px)"),
      TB: window.matchMedia("(max-width: 768px)"),
    };

  init();

  function init() {
    adjustIntroSize();
    createSpBg();
    createIndicator();
    initWrapperObserver();
    initSceneObserver();
    initNavObserver();
    bindEvent();
  }

  function bindEvent() {
    mq.SP.addEventListener("change", switchMq);
  }

  function switchMq(mq) {
    if (mq.matches) {
      wrapperObserver.unobserve($wrapper.get(0));
      navObserver.observe($nav.get(0));
    } else {
      wrapperObserver.observe($wrapper.get(0));
      navObserver.unobserve($nav.get(0));
    }
  }

  function adjustIntroSize() {
    var headerHeight = $(".brand-Header").outerHeight(true);
    $("#scene1, #scene1 .jb-Scene_inner").css(
      "min-height",
      "calc(100vh - " + headerHeight + "px)"
    );
  }

  function createSpBg() {
    $scene.each(function (i) {
      $(".jb-SpBg").append(
        '<div id="bg' + i + '" class="jb-SpBg_bg"></div>'
      );
    });
    $bg = $(".jb-SpBg_bg");
  }

  function initWrapperObserver() {
    wrapperObserver = new IntersectionObserver(doWhenScenesIntersected, {
      rootMargin: "-70% 0px 0px",
      threshold: 0,
    });
    wrapperObserver.observe($wrapper.get(0));
  }

  function doWhenScenesIntersected(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $indicator.fadeIn();
      } else {
        $indicator.fadeOut();
      }
    });
  }

  function initSceneObserver() {
    sceneObserver = new IntersectionObserver(doWhenSceneIntersected, {
      rootMargin: "-50% 0px",
      threshold: 0,
    });
    $scene.each(function () {
      sceneObserver.observe(this);
    });
  }

  function doWhenSceneIntersected(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (mq.SP.matches) {
          changeBG($scene.index($(entry.target)));
        } else if (!mq.TB.matches) {
          changeIndicator($scene.index($(entry.target)) + 1);
        }
      }
    });
  }

  function initNavObserver() {
    var option = {
      rootMargin: "0px",
      threshold: 0,
    };
    navObserver = new IntersectionObserver(doWhenNavIntersected, option);
    navObserver.observe($nav.get(0));
  }
  function doWhenNavIntersected(entries) {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        $bgs.addClass();
      }
    });
  }
  function changeBG(num) {
    var current = $bg.eq(num);
    var className = "-active";
    $bg.not(current).removeClass(className);
    current.addClass(className);
  }

  function createIndicator() {
    var elem = "";
    $scene.each(function (i) {
      var id = $(this).attr("id");
      elem += `<li><a href="#${
        id === "scene1" ? "top" : "scene" + (i + 1)
      }"><span class="brand-sr-only">Scene${i + 1}</span></a></li>`;
    });
    $indicator.append("<ul>" + elem + "</ul>");
  }

  function changeIndicator(num) {
    var foo = $indicator.find("a");
    var current = foo.eq(num - 1);
    var className = "-active";
    foo.not(current).removeClass(className);
    current.addClass(className);
  }
})($brand);
